import { FeatureToggle } from "./FeatureToggles.Generated";

export function isFeatureActive(featureToggle: FeatureToggle): boolean {
    const state = featureStateIfDefined(featureToggle);
    if (state === undefined) {
        throw new Error("FT class not found on <html>: " + FeatureToggle[featureToggle]);
    }
    return state;
}

export function featureStateIfDefined(featureToggle: FeatureToggle): boolean | undefined {
    //features may not be defined on non-logged-in-pages.
    const htmlClasses = document.documentElement.classList;
    return htmlClasses.contains("OFF-" + FeatureToggle[featureToggle])
        ? false
        : htmlClasses.contains("ON-" + FeatureToggle[featureToggle])
            ? true
            : undefined;
}

